import React, { useEffect, useState } from "react";
import {
  DetailsList,
  DetailsListLayoutMode,
} from "@fluentui/react/lib/DetailsList";
import { DefaultButton } from "@fluentui/react/lib/Button";
import { SelectionMode } from "@fluentui/react/lib/Selection";
import { TooltipHost } from "@fluentui/react/lib/Tooltip";
import CONSTANT from "../../../constant";
import moment from "moment";
import Header from "../../../component/common/Header";
import { getListExec } from "../../../actions/DakManagement";

function getColumnsOutbound(onUpdateClick) {
  return [
    {
      key: "to",
      name: "To",
      fieldName: "to",
      minWidth: 50,
      maxWidth: 100,
      isResizable: true,
    },
    {
      key: "description",
      name: "Description",
      fieldName: "description",
      minWidth: 100,
      maxWidth: 200,
      isResizable: true,
    },
    {
      key: "awb",
      name: "AWB",
      fieldName: "awb",
      minWidth: 100,
      maxWidth: 200,
      isResizable: true,
    },
    {
      key: "name",
      name: "Created By",
      fieldName: "name",
      minWidth: 200,
      maxWidth: 300,
      isResizable: true,
    },
    {
      key: "createdOn",
      name: "Created On",
      fieldName: "createdOn",
      minWidth: 100,
      maxWidth: 200,
      isResizable: true,
    },
    {
      key: "type",
      name: "Type",
      fieldName: "type",
      minWidth: 100,
      maxWidth: 200,
      isResizable: true,
    },
    {
      key: "status",
      name: "Status",
      fieldName: "status",
      minWidth: 100,
      maxWidth: 200,
      isResizable: true,
    },
    {
      key: "mailType",
      name: "Mail Type",
      fieldName: "mailType",
      minWidth: 100,
      maxWidth: 200,
      isResizable: true,
    },
  ];
}

function getColumnsInbound(onUpdateClick) {
  return [
    {
      key: "from",
      name: "From",
      fieldName: "from",
      minWidth: 50,
      maxWidth: 100,
      isResizable: true,
    },
    {
      key: "description",
      name: "Description",
      fieldName: "description",
      minWidth: 100,
      maxWidth: 200,
      isResizable: true,
    },
    {
      key: "awb",
      name: "AWB",
      fieldName: "awb",
      minWidth: 100,
      maxWidth: 200,
      isResizable: true,
    },
    {
      key: "name",
      name: "Created By",
      fieldName: "name",
      minWidth: 200,
      maxWidth: 300,
      isResizable: true,
    },
    {
      key: "createdOn",
      name: "Created On",
      fieldName: "createdOn",
      minWidth: 100,
      maxWidth: 200,
      isResizable: true,
    },
    {
      key: "type",
      name: "Type",
      fieldName: "type",
      minWidth: 100,
      maxWidth: 200,
      isResizable: true,
    },
    {
      key: "status",
      name: "Status",
      fieldName: "status",
      minWidth: 100,
      maxWidth: 200,
      isResizable: true,
    },
    {
      key: "mailType",
      name: "Mail Type",
      fieldName: "mailType",
      minWidth: 100,
      maxWidth: 200,
      isResizable: true,
    },
    {
      key: "update",
      name: "Action",
      fieldName: "update",
      minWidth: 100,
      maxWidth: 200,
      isResizable: true,
      onRender: (item) => {
        return (
          <DefaultButton
            disabled={item.type.toLowerCase() === "outbound" || item.status}
            onClick={() => onUpdateClick(item)}
          >
            Update
          </DefaultButton>
        );
      },
    },
  ];
}

function List(props) {
  const [data, setData] = useState(null);
  const outboundColumns = getColumnsOutbound(onUpdateClick);
  const inboundColumns = getColumnsInbound(onUpdateClick);

  async function getData() {
    const { result } = await getListExec();
    setData(result);
  }

  useEffect(() => {
    getData();
  }, []);

  function onUpdateClick(item) {
    props.history.push({
      pathname: CONSTANT.component.dakManagementUpdate.url,
      search: `?id=${item.id}`,
      state: { details: item },
    });
  }

  function getMailStatus(item) {
    if (item.type === "Inbound") {
      return item.status ? "Received" : "Not Received";
    }
    if (item.type === "Outbound") {
      return item.status ? "Dispatched" : "Not Dispatched";
    }
  }

  function _renderItemColumn(item, index, column) {
    const fieldContent = item[column.fieldName];

    switch (column.key) {
      case "to":
        return (
          <TooltipHost
            content={fieldContent}
            calloutProps={{ gapSpace: 0 }}
            styles={{ root: { display: "inline-block" } }}
          >
            <span style={{ fontSize: "14px", textAlign: "center" }}>
              {fieldContent.slice(0, 13) || "-"}
            </span>
          </TooltipHost>
        );
      case "from":
        return (
          <TooltipHost
            content={fieldContent}
            calloutProps={{ gapSpace: 0 }}
            styles={{ root: { display: "inline-block" } }}
          >
            <span style={{ fontSize: "14px", textAlign: "center" }}>
              {fieldContent.slice(0, 13) || "-"}
            </span>
          </TooltipHost>
        );
      case "description":
        return (
          <TooltipHost
            content={fieldContent}
            calloutProps={{ gapSpace: 0 }}
            styles={{ root: { display: "inline-block" } }}
          >
            <span style={{ fontSize: "14px", textAlign: "center" }}>
              {fieldContent.slice(0, 13) || "-"}
            </span>
          </TooltipHost>
        );
      case "awb":
        return (
          <span style={{ fontSize: "14px", textAlign: "center" }}>
            {fieldContent || "-"}
          </span>
        );
      case "createdOn":
        return (
          <span style={{ fontSize: "14px", textAlign: "center" }}>
            {moment(fieldContent).format("DD-MM-YYYY")}
          </span>
        );
      case "status":
        return (
          <span style={{ fontSize: "14px", textAlign: "center" }}>
            {getMailStatus(item)}
          </span>
        );
      default:
        return (
          <span style={{ fontSize: "14px", textAlign: "center" }}>
            {fieldContent}
          </span>
        );
    }
  }

  return (
    <>
    <style jsx>
      {`
      .ms-DetailsList-headerWrapper .root-64
      {background: linear-gradient(135deg, #3580c3 0%, #056caf 100%) !important; color:#fff;
       padding-top:0px; border-radius: 8px 8px 0px 0px;}
      .ms-DetailsList-headerWrapper .root-64 .root-81{color:#fff; background: transparent;}
      `}
    </style>
    <div className="container-fluid h-screen">
      <div className="row h-full">
        {/* <div className="col-md-2 px-0">
          <Header />
        </div> */}
        <div className="col-md-12 h-full py-2">
          <div className="card homedob">
            <div className="col-md-12 h-10">
              <h1 className="page-title">DAK List</h1>
            </div>
            <div className="h-5/6">
              <div className="col-md-12 h-2/4 overflow-hidden">
                <p className="font-semibold text-base my-2">Outbound</p>
                <div className="overflow-auto h-full">
                  <DetailsList
                    items={data ? data.outbound : []}
                    columns={outboundColumns}
                    getKey={(item) => `${item.id}`}
                    setKey="none"
                    layoutMode={DetailsListLayoutMode.justified}
                    isHeaderVisible={true}
                    onRenderItemColumn={_renderItemColumn}
                    selectionMode={SelectionMode.none}
                  />
                </div>
              </div>
              <div className="col-md-12 h-2/4 mt-3">
                <p className="font-semibold text-base my-2">Inbound</p>
                <div className="overflow-auto h-full">
                  <DetailsList
                    items={data ? data.inbound : []}
                    columns={inboundColumns}
                    getKey={(item) => `${item.id}`}
                    setKey="none"
                    layoutMode={DetailsListLayoutMode.justified}
                    isHeaderVisible={true}
                    onRenderItemColumn={_renderItemColumn}
                    selectionMode={SelectionMode.none}
                  />
                </div>
              </div>
            </div>
            </div>
        </div>
      </div>
    </div>
    </>
  );
}

export default List;
